import { Button, Typography } from '@mui/material'
import { FastForward } from '@mui/icons-material'
import { Grid } from '../../../../components/UniversalComponents'
import DevicesForm from '../../../../components/Admin/Devices/DevicesForm'

const Step1Boat = ({ setNextStep, permissionsCheck }) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    align="center"
                    variant="h5"
                    color="warning"
                    sx={{ margin: 2 }}
                >
                    If you already have a device provisioned you can:
                    {
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setNextStep(2)}
                            sx={{ width: 200, marginLeft: 5 }}
                            endIcon={<FastForward />}
                        >
                            Skip Step
                        </Button>
                    }
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <DevicesForm
                    formTitle="Configure A Telematics Device"
                    row={{}}
                    onClose={() => setNextStep(2)}
                    saveCache={() => {}}
                    minimizeModal={() => {}}
                    permissionCheck={permissionsCheck}
                    quickStart={true}
                />
            </Grid>
        </Grid>
    )
}

export default Step1Boat
